var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 46,
    viewBox: "0 0 49 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.1085 25.875C46.6352 37.2207 36.5573 46 24.3442 46C12.1312 46 2.05326 37.2207 0.580078 25.875H14.3653C15.3662 25.875 16.301 25.3945 16.8562 24.5949L20.6401 19.144L23.3871 34.9726C23.8333 37.5435 27.3255 38.2634 28.831 36.0949L35.9254 25.875H48.1085ZM0.580078 20.125C2.05326 8.77935 12.1312 0 24.3442 0C36.5573 0 46.6352 8.77935 48.1085 20.125H34.3232C33.3223 20.125 32.3875 20.6055 31.8322 21.4051L28.0484 26.8559L25.3014 11.0273C24.8552 8.45652 21.3629 7.73666 19.8575 9.90524L12.7631 20.125H0.580078Z",
    fill: "#321E5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector12);
export default __webpack_public_path__ + "static/media/Vector (1) 2.01e65fcf609582c8433113737a432903.svg";
export { ForwardRef as ReactComponent };